<!--
 * @Author: gang.liu
 * @Date: 2021-06-29 14:21:22
 * @LastEditTime: 2021-06-29 15:32:53
 * @LastEditors: gang.liu
 * @Description:
 * @api-property:
 * @api-event:
 * @api-method:
-->
<template>
  <div
    v-if="showflag"
    class="
      w-full
      bg-primary
      flex
      items-center
      justify-between
      flex-wrap
      box-border
      px-8
      py-4
      shadow-lg
    "
  >
    <gy-logo />
    <gy-navigation :nav="nav" />
    <!--    <span style="color: #fff" v-else>{{user.info.name}}</span>-->
    <el-dropdown
      trigger="click"
      v-if="user.info && Cookies.get('token')"
      @command="handleCommand"
    >
      <span class="el-dropdown-link" style="color: #fff">
        {{ user.info.name }}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="personalCenter" v-if="showPersonalCenter">
          个人中心
        </el-dropdown-item>
        <el-dropdown-item command="gobacks">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <slot name="info" v-else></slot>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Cookies from "js-cookie";
export default {
  name: "GyHeader",
  data() {
    return {
      Cookies,
      nav: [],
      showflag: true,
    };
  },
  computed: {
    ...mapState(["user"]),
    showPersonalCenter() {
      return !!this.user.info || !!Cookies.get("token");
    },
  },
  created() {
    if (this.$route.path == "/register" && this.browserRedirect() == "phone") {
      this.showflag = false;
    }
  },
  watch: {
    $route(to, from) {
      console.log(to.path, from.path);
      if (to.path == "/register" && this.browserRedirect() == "phone") {
        this.showflag = false;
      }
    },
  },
  mounted() {
    this.nav = [
      {
        path: `https://${
          window._GLOBAL_.DEPLOY_MODEL == "prod"
            ? ""
            : window._GLOBAL_.DEPLOY_MODEL + "_"
        }clinical.241210.com/`,
        name: "归源诊疗协同",
      },
      // {
      //   path: `https://${
      //     window._GLOBAL_.DEPLOY_MODEL == "prod"
      //       ? ""
      //       : window._GLOBAL_.DEPLOY_MODEL + "_"
      //   }internalcourse.241210.com/home`,
      //   name: "实训课堂",
      // },
      {
        path: "/chineseMedicine",
        name: "实训课堂",
      },
      {
        path: `https://${
          window._GLOBAL_.DEPLOY_MODEL == "prod"
            ? ""
            : window._GLOBAL_.DEPLOY_MODEL + "_"
        }study.241210.com/study/pathogeny`,
        name: "医案学习",
      },
      {
        path: "/consultative",
        name: "行业咨询",
      },
      {
        path: "/medicineInfo",
        name: "药品信息",
      },
      // {
      //   path: "/cooperation",
      //   name: "商务合作",
      // },
    ];
  },
  methods: {
    handleCommand(command) {
      if (command == "gobacks") {
        Cookies.remove("token", {
          domain: ["localhost"].includes(document.domain)
            ? document.domain
            : ".241210.com",
        });
        localStorage.removeItem("user-info");
        localStorage.removeItem("token");
        this.$store.state.user.info = null;
        this.$router.push({
          path: "/login",
        });
      }
      if (command === "personalCenter") {
        window.open(
          `https://${
            window._GLOBAL_.DEPLOY_MODEL == "prod"
              ? ""
              : window._GLOBAL_.DEPLOY_MODEL + "_"
          }personalweb.241210.com/user/portal`
        );
      }
    },
    browserRedirect() {
      let sUserAgent = navigator.userAgent.toLowerCase();
      let bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
      let bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
      let bIsMidp = sUserAgent.match(/midp/i) == "midp";
      let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
      let bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
      let bIsAndroid = sUserAgent.match(/android/i) == "android";
      let bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
      let bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
      if (
        bIsIpad ||
        bIsIphoneOs ||
        bIsMidp ||
        bIsUc7 ||
        bIsUc ||
        bIsAndroid ||
        bIsCE ||
        bIsWM
      ) {
        return "phone";
      } else {
        return "pc";
      }
    },
  },
};
</script>

<style lang="less">
// @import "../../styles/index";
// .gy-header {
//   // width: 100%;
//   // display: flex;
//   // align-items: center;
//   // justify-content: space-between;
//   // flex-wrap: wrap;
//   // background-color: @theme-color;
//   padding: 30px 35px;
//   // box-sizing: border-box;
// }
</style>
